export const pagesDevicesAlertsEn = {
  filter: {
    deviceGroupAll: 'All device groups',
    deviceGroupNoResults: 'No device groups found',
    deviceGroupSearch: 'Search device groups…',
    ruleAll: 'All assignment rules',
    ruleNoResults: 'No assignment rules found',
    ruleSearch: 'Search assignment rules…'
  },
  helpToggle: {
    toBeAssigned: {
      body: 'A person who is targeted by a rule but has no device assigned',
      title: 'To Be Assigned?'
    },
    unknownAssignment: {
      body: 'A person who is assigned a device that falls outside any rule',
      title: 'Unknown Assignment?'
    }
  },
  pageTitle: 'Device alerts',
  searchPlaceholder: {
    unknownAssignment: 'Search device name…'
  },
  sidebar: {
    closeSideTab: 'Close Sidebar',
    openSideTab: 'Open Sidebar',
    title: 'Alert categories',
    toBeAssigned: 'To Be Assigned',
    unknownAssignment: 'Unknown Assignment'
  }
};